import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { LockKeyhole, ChevronLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const error = params.get("error");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Skip /me check if returning from OAuth callback
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    (async () => {
      try {
        const r = await axios.get(`${API}/auth/me`, { withCredentials: true });
        if (r.data?.is_admin) navigate("/admin", { replace: true });
      } catch (_) {
        // not logged in
      } finally {
        setChecking(false);
      }
    })();
  }, [navigate]);

  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-ink-900 text-white relative overflow-hidden flex items-center justify-center px-6">
      <div className="absolute inset-0 pointer-events-none opacity-50"
        style={{
          background:
            "radial-gradient(circle at 20% 30%, rgba(197,160,89,0.15), transparent 45%), radial-gradient(circle at 80% 70%, rgba(197,160,89,0.08), transparent 50%)",
        }}
      />
      <button
        onClick={() => navigate("/")}
        data-testid="admin-back-home-btn"
        className="absolute top-6 left-6 flex items-center gap-2 text-white/60 hover:text-gold-pale text-sm transition-colors"
      >
        <ChevronLeft size={16} /> Back to site
      </button>

      <div className="relative z-10 w-full max-w-md">
        <div className="glass-gold rounded-2xl p-10 border border-gold/30 shadow-2xl">
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center">
              <LockKeyhole className="text-gold-pale" size={22} />
            </div>
          </div>
          <h1 className="text-3xl text-center font-display text-gradient-gold tracking-wide">
            Admin Console
          </h1>
          <p className="text-center text-white/60 mt-2 text-sm">
            CA$H OUT NEVER CRASH OUT
          </p>

          {error === "not_authorized" && (
            <div className="mt-6 p-3 rounded-lg border border-red-500/40 bg-red-500/10 text-red-200 text-sm text-center" data-testid="admin-login-unauthorized">
              That Google account isn’t whitelisted for admin access.
            </div>
          )}

          <button
            onClick={startLogin}
            disabled={checking}
            data-testid="admin-google-login-btn"
            className="btn-gold w-full mt-8 py-3 rounded-xl font-medium tracking-wide disabled:opacity-50 transition-all"
          >
            {checking ? "Checking session…" : "Sign in with Google"}
          </button>

          <p className="text-center text-white/40 text-xs mt-6">
            Access is restricted to authorized administrators.
          </p>
        </div>
      </div>
    </div>
  );
}
